/* eslint-disable import/prefer-default-export */
export const USER_TYPES = {
  Parent: 'parents',
  Therapist: 'therapist',
  Clinic: 'school_admin',
  SuperUser: 'superUser',
}
